import {
  ApiResponse,
  EntitlementsApiResponse,
  entitlementsBaseUrl,
  entitlementsRoutes,
  GetSupportPlansResponse,
  PersonalizedSupportInquiryRequestData,
  PersonalizedSupportInquiryResponse,
  UpdateSupportPlanRequestData,
  SupportPlanResponse,
} from "@twiliointernal/e2-commons-shared-definitions";
import Client from "./client";

export default class EntitlementsApi extends Client {
  constructor() {
    super(entitlementsBaseUrl);
  }

  getSupportPlan = async (): Promise<
    EntitlementsApiResponse<GetSupportPlansResponse>
  > => {
    const response: ApiResponse<GetSupportPlansResponse> = await this.get({
      path: entitlementsRoutes.getSupportPlan,
      requestOptions: {
        credentials: "include",
      },
    });

    return response as EntitlementsApiResponse<GetSupportPlansResponse>;
  };

  updateSupportPlan = async (
    data: UpdateSupportPlanRequestData
  ): Promise<EntitlementsApiResponse<SupportPlanResponse>> => {
    const csrf = await this.getCsrf();
    const body = JSON.stringify(data);
    const headers = {
      "Content-Type": "application/json",
      "x-twilio-csrf": csrf,
    };

    const response = await this.put({
      path: entitlementsRoutes.updateSupportPlan,
      body,
      headers,
      requestOptions: {
        credentials: "include",
      },
    });

    return response as EntitlementsApiResponse<SupportPlanResponse>;
  };

  sendPersonalizedSupportInquiry = async (
    data: PersonalizedSupportInquiryRequestData
  ): Promise<EntitlementsApiResponse<PersonalizedSupportInquiryResponse>> => {
    const csrf = await this.getCsrf();
    const body = JSON.stringify(data);
    const headers = {
      "Content-Type": "application/json",
      "x-twilio-csrf": csrf,
    };

    const response = await this.post({
      path: entitlementsRoutes.sendPersonalizedSupportInquiry,
      body,
      headers,
      requestOptions: {
        credentials: "include",
      },
    });
    return response as EntitlementsApiResponse<PersonalizedSupportInquiryResponse>;
  };
}
